import { mmFetchWithResponse } from '../mmFetchWithResponse';

const baPerfectOrderApi = {
    /**
     * Fetch the Blue Apron Perfect Order Report rows.
     * start/end are optional ISO dates (YYYY-MM-DD); the backend defaults to
     * the last 60 days and clamps the span server-side when they are omitted.
     */
    getPerfectOrderReport: async ({ end, signal, start } = {}) => {
        const params = new URLSearchParams();
        if (start) {
            params.set('start', start);
        }
        if (end) {
            params.set('end', end);
        }
        const query = params.toString();
        const url = `api/fbm/v1/ba/por${query ? `?${query}` : ''}`;
        return mmFetchWithResponse(url, { method: 'GET', signal });
    },
};

export { baPerfectOrderApi };
